import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles({
  numberInputText: {
    width: 55,
    borderRadius: 4,
    border: "1px solid #DADCE0",
    paddingLeft: 7,
    paddingRight: 7,
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 22,
    fontWeight: 500,
    textAlign: "center",
    "&:focus": {
      outline: "none !important",
      border: (props) => `1px solid ${props.currentTheme.primaryColor}`,
    },
    "&:hover": {
      outline: "none",
    },
  },
  alignCenter: {
    verticalAlign: "middle",
  },
  outlineRed: {
    borderColor: "red",
    "&:focus": {
      borderColor: "red !important",
    },
  },
});
export default useStyles;
